<template>
  <!-- 包裹详情-->
  <el-drawer
    :visible.sync="dialogVisible" center direction="ltr"
    size="1200px"
  >
    <template #title>
      <div class="title">
        <span class="titleName">{{ $t('GlobalSetObj.bagNumber') }}</span>
        <span class="titleName" style="margin-left: 15px">{{ detailObj.bagNumber }}</span>
      </div>
    </template>
    <div class="warp" style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane :label="$t('routes.packageConsolidationDetails')" name="1">
          <div style="line-height: 28px; margin-bottom: 10px">
            <div>
              <span class="detailLabel">{{ $t('routes.CollectionTime') }}: </span>
              <span>{{ detailObj.baggingTime || '--' }}</span>
            </div>
            <div>
              <span class="detailLabel">{{ $t('collectionCenter.operationType') }}: </span>
              <span>{{ detailObj.operationType || '--' }}</span>
            </div>
            <div>
              <span class="detailLabel">{{ $t('collectionCenter.businessT') }}: </span>
              <span>{{ detailObj.businessType || '--' }}</span>
            </div>
            <div>
              <span class="detailLabel">{{ $t('collectionCenter.NumberPackages') }}: </span>
              <span>{{ detailObj.packageCount || '--' }}</span>
            </div>
            <div>
              <span class="detailLabel">{{ $t('routes.consolidationOperator') }}: </span>
              <span>{{ detailObj.operationUserName || '--' }}</span>
            </div>
            <div>
              <span class="detailLabel">{{ $t('routes.consolidationOperationHub') }}: </span>
              <span>{{ detailObj.operationSiteName || '--' }}</span>
            </div>
          </div>
          <div>
            <div
              v-for="(item, index) in detailObj.transportRecords"
              :key="index"
              style="line-height: 28px; margin-bottom: 10px"
            >
              <div class="detailLabel">
                <span>{{ $t('routes.transportationCount01') }}</span>
                <span>{{ `${index + 1}` }}</span>
                <span>{{ $t('routes.transportationCount02') }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('collectionCenter.loadingScanningTime') }}: </span>
                <span>{{ item.scanTime || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('routes.loadingCompletionTime') }}: </span>
                <span>{{ item.loadTime || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('routes.loadingOperator') }}: </span>
                <span>{{ item.loadUserName || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('GlobalSetObj.licensePlateNumber') }}: </span>
                <span>{{ item.vehicleNumber || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('GlobalSetObj.nextStation') }}: </span>
                <span>{{ item.nextSiteName || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('GlobalSetObj.unCarTime') }}: </span>
                <span>{{ item.unloadTime || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('routes.unloadingOperator') }}: </span>
                <span>{{ item.unloadUserName || '--' }}</span>
              </div>
              <div>
                <span class="detailLabel">{{ $t('collectionCenter.unloadDot') }}: </span>
                <span>{{ item.unloadSiteName || '--' }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('collectionCenter.infoPackage')" name="2">
          <div style="margin-bottom: 10px; display: flex">
            <div class="selectLabel">
              <el-select v-model="searchForm.params.selectType">
                <el-option key="1" :label="$t('GlobalSetObj.waybillNumber')" :value="1" />
                <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
              </el-select>
              <el-input
                v-model="searchForm.params.inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1"
                clearable
                type="textarea"
              />
            </div>
            <div style="margin: 32px 0 0 10px">
              <!--搜索-->
              <el-button
                size="small" type="primary" @click="getSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <!--重置-->
              <el-button
                size="small" type="info" @click="resetForm"
              >{{ $t('newOrder.reset') }}
              </el-button>
              <el-button
                size="small" type="success" @click="exportToExcel"
              >{{ $t('newOrder.export') }}
              </el-button>
            </div>
          </div>
          <!--  表格数据  -->
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
            border
            style="width: 100%"
          >
            <el-table-column
              :label="$t('GlobalSetObj.serial')"
              align="center"
              type="index"
              width="80"
            />
            <el-table-column
              v-for="item in tableHeaderList"
              :key="item.id"
              :label="item.label"
              :min-width="item.cloWidth"
              :prop="item.prop"
            >
              <template slot-scope="scope">
                <div>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination
              :current-page.sync="searchForm.pageNumber"
              :page-size.sync="searchForm.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: 15px 0"
              @current-change="getSearch"
              @size-change="getSearch"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-drawer>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList';
import { jibaoExportPackageDetail, jibaoPackageDetail } from '@/api/newExpressAPI';

export default {
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          selectType: 1,
          inputValue: ''
        }
      },
      tableData: [],
      total: 0,
      tableHeaderList: [
        {
          id: 1,
          label: this.$t('GlobalSetObj.waybillNumber'),
          prop: 'waybillNumber',
          cloWidth: 180
        },
        {
          id: 2,
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanOrderNumber',
          cloWidth: 180
        },
        { id: 3, label: this.$t('routes.CollectionTime'), prop: 'createTime', cloWidth: 180 },
        {
          id: 4,
          label: this.$t('routes.consolidationOperator'),
          prop: 'createUserName',
          cloWidth: 180
        }
      ],
      detailObj: {},
      activeName: '1'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab.label, event);
    },
    showDetail(row) {
      console.log(row, 'SHOW');
      this.detailObj = row;
      this.activeName = '1';
      this.dialogVisible = true;
      this.resetForm();
    },
    getSearch() {
      let inputValList = [];
      if (this.searchForm.params.inputValue) {
        // 单号格式化，去除空格
        const orderNumber = this.searchForm.params.inputValue.split('\n');
        orderNumber.map((item) => {
          if (item) {
            inputValList.push(item.trim());
          }
        });
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          bagNumber: this.detailObj.bagNumber,
          waybillNumberList: [],
          scanOrderNumberList: []
        }
      };
      if (this.searchForm.params.selectType === 1) {
        data.params.waybillNumberList = inputValList;
      } else {
        data.params.scanOrderNumberList = inputValList;
      }
      jibaoPackageDetail(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    async exportToExcel() {
      let inputValList = [];
      if (this.searchForm.params.inputValue) {
        inputValList = this.searchForm.params.inputValue.split('\n');
      }
      const data = {
        bagNumber: this.detailObj.bagNumber,
        waybillNumberList: [],
        scanOrderNumberList: []
      };
      if (this.searchForm.params.selectType === 1) {
        data.waybillNumberList = inputValList;
      } else {
        data.scanOrderNumberList = inputValList;
      }
      const res = await jibaoExportPackageDetail(data);
      if (res.code === 200) {
        const toRes = await goResourceTaskList();
        if (toRes) {
          this.dialogVisible = false;
        }
      }
    },
    resetForm() {
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          selectType: 1,
          waybillNumber: ''
        }
      };
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.warp >>> .el-form-item {
  margin-bottom: 0 !important;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  font-weight: bold;
  text-align: left;
  margin-bottom: 5px;
}

.detailLabel {
  font-size: 14px;
  font-weight: 700;
  color: #909399;
  margin-right: 15px;
}
</style>
